import styled from 'styled-components';

export const ContainerStyled = styled.section`
	height: 85vh;
	background-color: var(--background-show-case);
`;
